export class AttributeDatatype {
  public static text = 'text';
  public static translations = 'translations';
  public static number = 'number';
  public static boolean = 'boolean';
  public static date = 'date';
  public static codesystem = 'codesystem';
  public static dictionary = 'dictionary';
  public static multiselectCodesystem = 'codesystem-multiselect';

  public static values: Array<string> = [
    AttributeDatatype.text,
    AttributeDatatype.translations,
    AttributeDatatype.number,
    AttributeDatatype.boolean,
    AttributeDatatype.date,
    AttributeDatatype.codesystem,
    AttributeDatatype.dictionary,
    AttributeDatatype.multiselectCodesystem
  ];
}
